import type { InterfaceElementDto } from '@/modules/common/dto/interface-element.dto.ts';
import type { Access } from '@/modules/common/enums/access.enum.ts';
import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';

export class AccessAdapter {
  private static map(response: InterfaceElementDto): Access {
    return response.GUIE_ID;
  }

  static mapList(response: ItemsDto<InterfaceElementDto>) {
    return response.items.map(AccessAdapter.map);
  }
}
